module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公众账号ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.form.app_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "app_id", $$v)
      },
      expression: "form.app_id"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("微信支付分配的公众账号ID（企业号corpid即为此appId）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.form.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v)
      },
      expression: "form.merchant_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "API密钥"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.form.key),
      callback: function($$v) {
        _vm.$set(_vm.form, "key", $$v)
      },
      expression: "form.key"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户证书"
    }
  }, [(_vm.form.cert_name) ? _c('span', [_vm._v(" " + _vm._s(_vm.form.cert_name))]) : _vm._e(), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "",
      "on-change": _vm.certHandleChange,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("微信商户平台(pay.weixin.qq.com)-->账户设置-->API安全-->证书下载 apiclient_cert.pem")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户证书秘钥"
    }
  }, [(_vm.form.cert_key_url) ? _c('span', [_vm._v(" " + _vm._s(_vm.form.cert_key_name))]) : _vm._e(), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "",
      "on-change": _vm.keyHandleChange,
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("微信商户平台(pay.weixin.qq.com)-->账户设置-->API安全-->证书下载 apiclient_key.pem")])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ff4ab14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff4ab14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/payment/wxpay.vue
// module id = 2760
// module chunks = 0